import { ProductOptionsColumn, ProductOptionsRow } from '@teko/discovery';
import { Caption, Flex, Shape, styled } from '@teko/ds-desktop';
import NextLink from 'next/link';
import React from 'react';

interface VariantItemProps {
  variant: ProductOptionsRow;
  onSelect: (variant: ProductOptionsColumn) => void;
  visible?: boolean;
}

export const ProductVariantItem: React.FC<VariantItemProps> = ({
  variant,
  onSelect,
  visible = true,
}: VariantItemProps) => {
  if (!variant.options?.length) return null;
  const selectedOption = variant.options.find((e) => e.selected);
  return (
    <Shape marginTop="s8">
      <Caption
        level={2}
        color="textSecondary"
        style={{ textTransform: 'uppercase' }}
      >
        {`${variant.title}${selectedOption ? `: ${selectedOption.label}` : ''}`}
      </Caption>
      <Flex marginTop="s8" flexWrap="wrap" maxWidth="calc(100% - 64px)">
        {variant.options.map((option, index) => (
          <WrapperOption
            href={`/${option.url}`}
            key={index}
            onClick={(e) => {
              e.preventDefault();
              onSelect(option);
            }}
            isActive={option.selected}
            isVisible={visible}
            blur={option.quantity === 0}
            className={`att-variant-${option.label}-sku-${option.sku}`}
          >
            {option.label}
          </WrapperOption>
        ))}
      </Flex>
    </Shape>
  );
};

interface WrapperOptionProps {
  isActive: boolean;
  isVisible?: boolean;
  blur?: boolean;
}

const WrapperOption = styled(NextLink)<WrapperOptionProps>(
  ({ isActive, theme, isVisible, blur }) => `
    border: 1px ${isActive ? theme.colors.primary500 : '#e0e0e0'} solid;
    position: relative;
    color: ${isActive ? theme.colors.primary500 : 'black'};
    background-color: ${isVisible || isActive === true ? '#fff' : '#e0e0e0'};
    text-transform: capitalize;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: ${isVisible || isActive === true ? 'pointer' : 'not-allowed'};
    opacity: ${blur ? '0.5' : '1'};
    border-radius: 4px;
    padding: 8px 16px;
    margin: 0 8px 8px 0;
    text-decoration: none;
`,
);
